const getSiblings = function (e) {
  const siblings = [];
  if (!e.parentNode) {
    return siblings;
  }
  let sibling = e.parentNode.firstChild;
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== e) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
};

function initializeAccordian() {
  const clickedAccordian = document.querySelectorAll(
    '.briefing-accordion-header',
  );
  if (clickedAccordian) {
    for (let i = 0; i < clickedAccordian.length; i += 1) {
      clickedAccordian[i].addEventListener('click', () => {
        const siblings = getSiblings(clickedAccordian[i]);
        let nextSibling;
        if (siblings.length > 1) {
          // eslint-disable-next-line prefer-destructuring
          nextSibling = siblings[1];
        } else {
          nextSibling = clickedAccordian[i].nextSibling.nextElementSibling;
        }
        nextSibling.classList.toggle('hide');
        clickedAccordian[i].children[0].classList.toggle('is-expanded');
      });
    }
  }
}

export default {
  initialize: initializeAccordian,
};
